import vendorTypes from './vendor.types';

export const addServiceStart = serviceData => ({
  type: vendorTypes.ADD_NEW_SERVICE_START,
  payload: serviceData
});

export const fetchServicesStart = (filters={}) => ({
  type: vendorTypes.FETCH_SERVICES_START,
  payload: filters
});

export const fetchVendorsStart = productName => ({
  type: vendorTypes.FETCH_VENDORS_START,
  payload: productName
});

export const setServices = services => ({
  type: vendorTypes.SET_SERVICES,
  payload: services
});

export const deleteServiceStart = productID => ({
  type: vendorTypes.DELETE_SERVICE_START,
  payload: productID
});

export const fetchServiceStart = productID => ({
  type: vendorTypes.FETCH_SERVICE_START,
  payload: productID
});

export const setService = service => ({
  type: vendorTypes.SET_SERVICE,
  payload: service
});